






















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BaseSnackbar extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: String, default: 'info' }) readonly color!: string
}
